import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Row,
  Col,
  Drawer,
  Button,
  Tooltip,
  Avatar,
  Dropdown,
  Divider,
  Typography,
  Badge,
} from "antd";
import { AiOutlineSetting, AiOutlineLogout } from "react-icons/ai";
import { CiLogout } from "react-icons/ci";
import { UserOutlined, MailOutlined, MailFilled } from "@ant-design/icons";
import { FiMenu, FiPower } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
// component
import LayoutMenu from "./layout_menu";
// redux
import { logOut } from "../../../store/auth/auth.action";
import { userSelector } from "../../../store/user/user.selector";
import { countSelector } from "../../../store/request/request.selector";

const { Text } = Typography;

const LayoutHeader = () => {
  // -------------------------- VAR --------------------------
  const navigate = useNavigate();
  // -------------------------- STATE --------------------------
  const [drawer, setDrawer] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const count = useSelector(countSelector);
  const firstName = user?.firstName || "";
  const lastName = user?.lastName || "";
  const avatar = user?.avatar || "";
  const email = user?.email || "";
  // -------------------------- FUNCTION --------------------------

  const toggleDrawer = () => {
    setDrawer(!drawer);
  };

  const closeDrawer = () => {
    setDrawer(false);
  };

  const navigateToSetting = () => {
    navigate("/setting");
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------

  const renderLogo = () => {
    return (
      <a href="/" target="_self" rel="noopener noreferrer">
        <div className="logo" />
      </a>
    );
  };

  const renderMobile = () => {
    return (
      <Row justify="space-between" align="middle">
        <Col flex="auto">{mobileButton()}</Col>
        <Col flex="auto">{renderRightNav()}</Col>
        {mobileDrawer()}
      </Row>
    );
  };

  const renderMailAlert = () => {
    return (
      <Tooltip placement="left" title="Mail Request">
        <Button
          style={{ marginRight: 15 }}
          type="text"
          icon={
            <Badge count={count} size="small">
              <MailFilled style={{ color: "white"}} />
            </Badge>
          }
          onClick={() => navigate(`/request`)}
        />
      </Tooltip>
    );
  };

  const logoutButton = () => {
    return (
      <Button
        type="text"
        onClick={() => dispatch(logOut())}
        icon={
          <span className="anticon">
            <CiLogout size={16} />
          </span>
        }
        style={{
          borderRadius: 5,
          width: "100%",
          textAlign: "left",
        }}
      >
        Logout
      </Button>
    );
  };

  const renderDropDown = () => {
    return (
      <Row gutter={[20]}>
        <Col span={4}>{renderLargeAvatar()}</Col>
        <Col span={20}>
          <div style={{ marginLeft: 20 }}>
            <strong style={{ fontSize: 20 }}>
              {firstName} {lastName}
            </strong>
            <br />
            <Text ellipsis={{ rows: 1 }}>{email}</Text>
          </div>
        </Col>
        <Divider />
        {renderSetting()}
        {logoutButton()}
      </Row>
    );
  };

  const renderSetting = () => {
    return (
      <Button
        onClick={navigateToSetting}
        type="text"
        style={{ width: "100%", textAlign: "left" }}
        icon={
          <span className="anticon">
            <AiOutlineSetting />
          </span>
        }
      >
        Account Settings
      </Button>
    );
  };

  const renderLargeAvatar = () => {
    if (avatar) {
      return <Avatar size="large" src={avatar} />;
    }
    return (
      <Button
        size="large"
        shape="circle"
        type="default"
        icon={<UserOutlined />}
      />
    );
  };

  const renderRightNav = () => {
    return (
      <Row
        style={{ display: "flex", alignItems: "center" }}
        justify="end"
        align="middle"
      >
        <Col style={{ marginRight: 10 }}>
          {renderMailAlert()}
          <Dropdown
            overlayStyle={{
              width: 250,
              backgroundColor: "white",
              padding: 20,
              border: "1px solid rgba(0,0,0,0.2)",
              borderRadius: 6,
              boxShadow: "1px 1px 3px 1px rgba(0,0,0,0.1)",
            }}
            dropdownRender={() => renderDropDown()}
            trigger={["click"]}
          >
            {renderUser()}
          </Dropdown>
        </Col>
      </Row>
    );
  };

  const mobileButton = () => {
    return (
      <Tooltip title="Menu">
        <Button
          shape="default"
          onClick={() => toggleDrawer()}
          style={{ padding: 6, borderRadius: 5 }}
        >
          <FiMenu style={{ fontSize: 18 }} />
        </Button>
        {renderTitle()}
      </Tooltip>
    );
  };

  const renderTitle = () => {
    return (
      <strong className="header-title">Admin Portal (Beauty System)</strong>
    );
  };

  const renderUser = () => {
    if (avatar) {
      return <Avatar src={avatar} />;
    }
    return <Button shape="circle" type="default" icon={<UserOutlined />} />;
  };

  const mobileDrawer = () => {
    return (
      <Drawer
        placement="left"
        closable={false}
        onClose={() => closeDrawer()}
        visible={drawer}
        className="drawer-container"
        width={280}
      >
        {renderLogo()}
        <Divider />
        <LayoutMenu mode="inline" />
        <Divider />
        <div style={{ padding: 10 }}>
          <Col style={{ margin: "10px 0px" }} span={24}>
            {renderSetting()}
          </Col>
          <Col span={24}>{logoutButton()}</Col>
        </div>
      </Drawer>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout.Header className="header-menu">{renderMobile()}</Layout.Header>
  );
};

export default LayoutHeader;
